// extracted by mini-css-extract-plugin
export default {"root":"UBWitnEk","collapseEmpty":"z2jlnXqX","withPlaceholder":"_83yrVUsR"};